import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { firstValueFrom } from 'rxjs';
import { practiceSessionTemplateResponse } from '../models/practiceSessionTemplateResponse';
import { drill } from '../models/drill';
import { saveDrillRequest } from '../models/saveDrillRequest';
import { savePracticeTemplateRequest } from '../models/savePracticeTemplateRequest';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private http:HttpClient, private configService:ConfigurationService) {
    this.baseUrl = this.configService.getApiEndpoint();
  }
  
  baseUrl:string;
  defaultPageSize:number = 100;

  async searchTemplates(username:string):Promise<Array<practiceSessionTemplateResponse>> {
      let endpoint = `${this.baseUrl}/practicesessiontemplates`;
      let result = await firstValueFrom(this.http.post<practiceSessionTemplateResponse[]>(endpoint, { username: username, pageNumber:1, pageSize: this.defaultPageSize }));
      return result;
  }

  async getTemplateById(username:string, id:number):Promise<practiceSessionTemplateResponse> {
    let endpoint = `${this.baseUrl}/practicesessiontemplates`;
    let result = await firstValueFrom(this.http.post<practiceSessionTemplateResponse[]>(endpoint, { username: username, id: id }));
    return result[0];
  }

  async saveTemplate(req:savePracticeTemplateRequest):Promise<void> {
    let endpoint = `${this.baseUrl}/practicesessiontemplate`;
    if(req.id) {

    }
    else {
      let result = await firstValueFrom(this.http.put(endpoint, req));
    }
    return;
  }

  async searchDrills(username:string):Promise<Array<drill>> {
    let endpoint = `${this.baseUrl}/drills`;
    let result = await firstValueFrom(this.http.post<drill[]>(endpoint, { username: username, pageNumber:1, pageSize: this.defaultPageSize }));
    return result;
  }

  async saveDrill(req:saveDrillRequest):Promise<void> {
    let endpoint = `${this.baseUrl}/drill`;
    if(req.id) {

    }
    else {
      let result = await firstValueFrom(this.http.put(endpoint, req));
    }
    return;
  }

}
